export default {
    title: 'Welkom!',
    text1: 'Wij bezorgen stijlvolle en duurzame bloemen en planten aan huis en maken samen met jou de wereld een beetje mooier...',
    text2Bold: 'Flowering a better world!',
    text3: 'Join the Family',
    button: 'Neem een kijkje in de shop',
};